import { Befehl7FormData, Befehl7FormSchema } from './schema'
import { Befehl7 } from '../../../models'
import {
  BefehlAuftrag_7_10Dto,
  BefehlAuftrag_7_20Dto,
  BefehlAuftrag_7_25Dto
} from '../../../dtos'
import { Befehl7DataDto } from '../../../dtos/befehl-7-dto'
import {
  createSimpleAuftrag,
  findAuftragByKennung,
  hasAuftrag
} from '../converter-utils'

export const convertModelToBefehl7FormData = (
  befehl?: Befehl7
): Befehl7FormData => {
  const formData = Befehl7FormSchema.parse({})

  if (!befehl?.auftraege) {
    return formData
  }

  // auftrag_7_10 enabled not changeable by user
  if (hasAuftrag(befehl.auftraege, '7.10')) {
    formData.auftrag_7_10.enabled = true
  }

  const auftrag720 = findAuftragByKennung(befehl.auftraege, '7.20') as
    | BefehlAuftrag_7_20Dto
    | undefined
  if (auftrag720) {
    formData.auftrag_7_20.enabled = true
    const feld721 = auftrag720.felder?.find((f) => f.kennung === '7.21')
    if (feld721) {
      formData.auftrag_7_20.field_7_21 = {
        signal: feld721.werte?.signal ?? '',
        zugmeldestelle: {
          art: feld721.werte?.zugmeldestelle?.art ?? '',
          name: feld721.werte?.zugmeldestelle?.name ?? ''
        }
      }
    }
  } else {
    formData.auftrag_7_20.enabled = false
  }

  formData.auftrag_7_25.enabled = hasAuftrag(befehl.auftraege, '7.25')

  return formData
}

export const convertBefehl7FormDataToModel = (
  formData: Befehl7FormData,
  frontendId: string
): Befehl7 => {
  const auftraege: Befehl7DataDto = []

  // Auftrag 7.10
  const auftrag710 = createSimpleAuftrag('7.10', formData.auftrag_7_10?.enabled)
  if (auftrag710) {
    auftraege.push(auftrag710 as BefehlAuftrag_7_10Dto)
  }

  // Auftrag 7.20
  if (formData.auftrag_7_20?.enabled) {
    auftraege.push({
      kennung: '7.20',
      felder: [
        {
          kennung: '7.21',
          werte: {
            signal: formData.auftrag_7_20?.field_7_21?.signal || '',
            zugmeldestelle: {
              art: formData.auftrag_7_20?.field_7_21?.zugmeldestelle?.art || '',
              name:
                formData.auftrag_7_20?.field_7_21?.zugmeldestelle?.name || ''
            }
          }
        }
      ]
    } as BefehlAuftrag_7_20Dto)
  }

  // Auftrag 7.25
  const auftrag725 = createSimpleAuftrag('7.25', formData.auftrag_7_25?.enabled)
  if (auftrag725) {
    auftraege.push(auftrag725 as BefehlAuftrag_7_25Dto)
  }

  return {
    kennung: '7',
    frontendId,
    auftraege
  }
}
